export enum AddOnCustomizeStep {
  GoBack = "GoBack",
  DisruptionProtection = "DisruptionProtection",
  CFAR = "CFAR",
  GoToCheckout = "GoToCheckout",
}

export enum AddOnCustomizeStepAlias {
  GoBack,
  AddOn1,
  AddOn2,
  GoToCheckout,
}
